import type { TError, TSpaceBase } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

/**
 * Query key for fetching a specific space by ID - non-hook version
 */
export const getSpaceQueryKey = (id: string) => [ENTITY, 'spaces', id];

/**
 * Query key for fetching a specific space by ID
 */
export const useGetSpaceQueryKey = (id: string) => getSpaceQueryKey(id);

/**
 * Hook to fetch a specific space by ID
 * Returns parent space with metadata
 *
 * @param id - Space ID (UUID)
 */
export const useGetSpace = (id: string) => {
  return useQuery<TSpaceBase, TError>({
    queryKey: useGetSpaceQueryKey(id),
    queryFn: async () => {
      const res = await axios.get<TSpaceBase>(`/community-hub/spaces/${id}`);
      return res.data;
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
